import getApolloClient from './client';

export default getApolloClient;
